var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rs-select',_vm._g(_vm._b({attrs:{"items":_vm.items}},'rs-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }